import React from "react";

import { TextField, Typography, Grid } from "@mui/material";

import { BlockStandard } from "components/admin/BlockStandard";
import { PhotoUploadGrid } from "components/forms/PhotoUploadGrid";

export type SolarPanelDetailsItem = {
  fotovoltaic_panels_quantity: string;
  fotovoltaic_panels_unit_power: string;
  fotovoltaic_panels_total_power: string;
  fotovoltaic_panels_pictures: File[];
};

export const emptySolarPanelDetails: SolarPanelDetailsItem = {
  fotovoltaic_panels_quantity: "",
  fotovoltaic_panels_unit_power: "",
  fotovoltaic_panels_total_power: "",
  fotovoltaic_panels_pictures: [],
};

type SolarPanelDetailsProps = {
  panelData: SolarPanelDetailsItem;
  onChange: (updated: SolarPanelDetailsItem) => void;
};

export const SolarPanelDetails = ({
  panelData,
  onChange,
}: SolarPanelDetailsProps) => {
  const handleQuantityChange = ({ target: { value } }) => {
    onChange({
      ...panelData,
      fotovoltaic_panels_quantity: value,
    });
  };

  const handleUnitPowerChange = ({ target: { value } }) => {
    onChange({
      ...panelData,
      fotovoltaic_panels_unit_power: value,
    });
  };

  const handleTotalPowerChange = ({ target: { value } }) => {
    onChange({
      ...panelData,
      fotovoltaic_panels_total_power: value,
    });
  };

  const handlePhotosChange = (photos: File[]) => {
    onChange({
      ...panelData,
      fotovoltaic_panels_pictures: photos,
    });
  };

  return (
    <BlockStandard>
      <Typography variant="subtitle1">Painéis fotovoltaicos</Typography>

      <Grid container direction="row" gap={0.5} justifyContent="space-between">
        <TextField
          label="Quantidade"
          placeholder="Ex. 24"
          variant="outlined"
          fullWidth
          value={panelData.fotovoltaic_panels_quantity}
          onChange={handleQuantityChange}
          sx={{ flex: 1 }}
        />

        <TextField
          label="Pot. Unitária (W)"
          placeholder="Ex.: 18W"
          variant="outlined"
          fullWidth
          value={panelData.fotovoltaic_panels_unit_power}
          onChange={handleUnitPowerChange}
          sx={{ flex: 1 }}
        />

        <TextField
          label="Pot. total (W)"
          placeholder="Ex.: 18W"
          variant="outlined"
          fullWidth
          value={panelData.fotovoltaic_panels_total_power}
          onChange={handleTotalPowerChange}
          sx={{ flex: 1 }}
        />
      </Grid>

      <PhotoUploadGrid
        photos={panelData.fotovoltaic_panels_pictures}
        onPhotosChange={handlePhotosChange}
      />
    </BlockStandard>
  );
};
